// extracted by mini-css-extract-plugin
export var fadeInAnimation = "textincolumns-module--fadeInAnimation--186c2";
export var text = "textincolumns-module--text--d574a";
export var wrapper = "textincolumns-module--wrapper--5fda2";